import React from 'react';
import { Feature, RenderOn } from '@econsult/econsult-ui/dist/components/FlagControlledFeature';
import { EmisCredentials } from 'components/EmisCredentials';
import { TableHeaderDivider, TableHeaderSmallText, TableHeaderTitleText } from 'components/Table';
import { HeaderColumn, HeaderRow } from 'components/Table/tableHeader';
import { STRINGS } from 'config';
import { CustomLandingPageMessage } from 'components/CustomLandingPageMessage';
import { OtherSettingsTableContainer } from 'components/OtherSettings/style';
import { CustomTeamsForm } from './CustomTeamsForm';

const {
  SETTINGS_FRONTEND_EMIS_CLOUD_ENABLED,
  CUSTOM_LANDING_PAGE_MESSAGE_ENABLED,
} = STRINGS.FEATURE_FLAGS;

export const OtherSettings = () => (
  <OtherSettingsTableContainer id="SkipToUserListMainContent" data-automation="OtherSettingsWrapper">
    <HeaderColumn>
      <HeaderRow>
        <HeaderColumn>
          <TableHeaderTitleText as="h1" data-automation="OtherSettingsPageTitleText">
            Other settings
          </TableHeaderTitleText>
          <TableHeaderSmallText data-automation="OtherSettingsDescription">
            Other settings to customise and manage your eConsult experience.
          </TableHeaderSmallText>
        </HeaderColumn>
      </HeaderRow>
      <TableHeaderDivider />
    </HeaderColumn>

    <Feature flags={[SETTINGS_FRONTEND_EMIS_CLOUD_ENABLED]}>
      <RenderOn>
        <EmisCredentials />
      </RenderOn>
    </Feature>

    <Feature flags={[CUSTOM_LANDING_PAGE_MESSAGE_ENABLED]}>
      <RenderOn>
        <CustomLandingPageMessage />
      </RenderOn>
    </Feature>

    <CustomTeamsForm />
  </OtherSettingsTableContainer>
);
